import styled from 'styled-components';
import { FlexView, Row, Text } from '@cuemath/comps';
import COLORS from 'constants/colors';

// FlexView is already display:flex + flex-direction:column, so these are just the
// overrides on top of it (a column layout — not a Row/Col grid element).
export const Root = styled(FlexView)`
  && {
    padding: 24px;
    gap: 16px;
  }
`;

export const Header = styled(FlexView)`
  && {
    align-items: flex-start;
    gap: 4px;
  }
`;

export const Title = styled(Text)`
  && {
    font-size: 20px;
    font-weight: 600;
    color: ${COLORS.ABBEY};
  }
`;

export const Subtitle = styled(Text)`
  && {
    font-size: 13px;
    color: ${COLORS.GRAY};
  }
`;

export const TabBar = styled(Row)`
  && {
    display: flex;
    gap: 0;
    border-bottom: 1px solid ${COLORS.GALLERY};
  }
`;

export const Tab = styled.button`
  padding: 10px 24px;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  color: ${({ $active }) => ($active ? COLORS.PRIMARY : COLORS.GRAY)};
  background: transparent;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? COLORS.PRIMARY : 'transparent')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    color: ${COLORS.PRIMARY};
  }
`;

export const Grid = styled.table`
  border-collapse: collapse;
  width: 100%;
  max-width: 880px;
  font-size: 13px;

  & th,
  & td {
    border: 1px solid ${COLORS.GALLERY};
    padding: 12px;
    text-align: center;
    vertical-align: middle;
  }

  & th {
    background-color: ${COLORS.WILD_SAND};
    font-weight: 600;
    color: ${COLORS.ABBEY};
  }

  & td.row-head {
    background-color: ${COLORS.WILD_SAND};
    font-weight: 600;
    text-align: left;
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-height: 48px;
  justify-content: center;
`;

export const FeeValue = styled.div`
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.ABBEY};
`;

export const Reference = styled(Text)`
  && {
    font-size: 11px;
    color: ${COLORS.SILVERCHALICE};
    line-height: 1.3;
  }
`;

export const FeeInput = styled.input`
  width: 90px;
  padding: 6px 8px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  font-size: 14px;
  text-align: center;

  &:focus {
    outline: none;
  }
`;

export const Empty = styled.div`
  color: ${COLORS.WHITE_5};
  font-size: 13px;
`;

export const Controls = styled(Row)`
  && {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    flex-wrap: wrap;
  }
`;

export const Field = styled(FlexView)`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const FieldLabel = styled(Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    color: ${COLORS.GRAY};
  }
`;

export const DateInput = styled.input`
  padding: 7px 10px;
  border: 1px solid ${COLORS.GALLERY};
  border-radius: 4px;
  font-size: 13px;
  color: ${COLORS.ABBEY};

  &:focus {
    outline: none;
    border-color: ${COLORS.PRIMARY};
  }
`;

export const Validity = styled(Text)`
  && {
    font-size: 11px;
    color: ${COLORS.GRAY};
    line-height: 1.3;
  }
`;

export const WindowBadge = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 8px;
  padding: 1px 6px;
`;

export const Audit = styled(Text)`
  && {
    font-size: 11px;
    color: ${COLORS.SILVERCHALICE};
    line-height: 1.3;
  }
`;

export const FieldError = styled(Text)`
  && {
    font-size: 11px;
    color: ${COLORS.RED};
  }
`;

export const SubmitRow = styled(Row)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }
`;
